import React from 'react';
import Card from '../../../core/layout/Card';
import Alert from '../../../core/layout/Alert';
import Separator from '../../../core/layout/Separator';
import SuspectUsageAlertListContainer from './SuspectUsageAlertListContainer';
import SuspectUsageAlertListFilterContainer from './SuspectUsageAlertListFilterContainer';
import SuspectUsageAlertFormDialogContainer from './SuspectUsageAlertFormDialogContainer';

const SuspectUsageAlertScene = () => (
  <div>
    <Alert title="How are alerts created?">
      <p>
        These alerts are generated by comparing the student's execution with the average execution of other students.
        The students in the list above may be having some trouble completing the exercise or studying incorrectly.
      </p>
    </Alert>
    <Separator size="xs"/>
    <Card title="Suspect Usage Alerts">
      <SuspectUsageAlertListFilterContainer />
    </Card>
    <Separator />
    <Card>
      <SuspectUsageAlertListContainer />
    </Card>
    <SuspectUsageAlertFormDialogContainer />
  </div>
);

export default SuspectUsageAlertScene;
